module.exports = {"id":"196978","name":"Callum Wilson","rating":"77","photo":"./data/images/photos/4/196978.png","club":{"name":"Bournemouth","logo":"./data/images/clubs/Bournemouth.png"},"positions":["BU"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/CallumWilson0.json
// module id = 690
// module chunks = 0